import styled from 'styled-components'

const Container = styled.div<{ isFromEdit: boolean }>`
  width: 100%;
  position: relative;
`

const Title = styled.p`
  margin: 0;
  margin-right: auto;
  font-size: 14px;
`

const Form = styled.div`
  display: flex;
  margin-top: 8px;
  width: 100%;
  gap: 0.5rem;
  position: relative;
  flex-direction: column;
  align-items: flex-end;
  text-align: left;
`

const DisableScreen = styled.div`
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  bottom: 0;
  opacity: 0.3;
  background-color: var(--color-selago-grey);
`

const Textarea = styled.textarea<{ isError: boolean; isFromEdit: boolean }>`
  position: relative;
  width: 100%;
  height: 88px;
  font-size: 14px;
  word-break: break-word;
  outline: none;
  border: none;
  //resize: none;
  border-color: ${({ isError }) => isError && 'var(--color-text-error)'};
`

const Error = styled.div`
  font-size: 12px;
  position: relative;
  color: var(--color-text-error);
  margin-top: -0.5rem;
  margin-right: auto;
`

const InputContainer = styled.div<{ isError: boolean; isFromEdit: boolean }>`
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 10px;
  border-color: ${({ isError }) => (isError ? 'var(--color-text-error)' : 'lightgrey')};

  * {
    padding: 1rem;
    border-radius: inherit;
  }

  & input {
    font-size: 14px;
    font-weight: 400;
    color: rgb(68, 68, 68);
    border-color: rgb(229, 229, 229);
    border-bottom: none;
    border-color: ${({ isError }) => isError && 'var(--color-text-error)'};
  }
`

const TitleInput = styled.input`
  font-weight: 600;
  font-size: ${({ isFromEdit }) => (isFromEdit ? '14px' : '16px')};
  color: rgb(68, 68, 68);
  border: none;
  outline: none;
  width: 100%;
`

const selectCustomStyles = {
  control: (provided, state) => {
    const error = !state.hasValue && !state.isFocused && state.selectProps.touched

    return {
      ...provided,
      border: error ? '1px solid red' : '1px solid var(--color-mischka-grey)',
      outline: 'none',
      boxShadow: 'none',
      borderRadius: 10,
      padding: '0.5rem',
      '&:hover': {
        border: error ? '1px solid red' : '1px solid rgba(53, 64, 82, 0.5)',
        boxShadow: 'none',
      },
    }
  },
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none',
  }),
  singleValue: provided => ({
    ...provided,
    color: 'var(--color-oxford-blue)',
    fontSize: 14,
  }),
  option: (provided, state) => {
    return {
      ...provided,
      fontSize: 14,
      cursor: 'pointer',
      backgroundColor: state.isFocused ? 'var(--color-hover-overlay-primary)' : 'var(--color-white)',
      color: 'var(--color-text-primary)',
      '&:hover': {
        fontSize: 14,
        backgroundColor: state.isFocused ? 'var(--color-hover-overlay-primary)' : 'var(--color-white)',
        color: 'var(--color-text-primary)',
      },
    }
  },
  menu: provided => ({
    ...provided,
    padding: 0,
    overflow: 'hidden',
  }),
  placeholder: provided => ({
    ...provided,
    color: 'rgba(53, 64, 82, 0.5)',
    fontSize: 14,
    width: 'max-content',
  }),
}

const SelectorContainer = styled.div`
  width: 100%;

  & > div:first-child {
    margin-bottom: 8px;
  }
`

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 0.5rem;
  position: relative;
  justify-content: flex-end;
`

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  gap: 0.5rem 1rem;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`

export const RowCell = styled.div<{ isError: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`

export {
  Container,
  Title,
  Form,
  DisableScreen,
  Textarea,
  Error,
  InputContainer,
  TitleInput,
  Footer,
  SelectorContainer,
  selectCustomStyles,
}
